import Yup from '../../../yup';

const mappSchema = Yup.object().shape({
    enabled: Yup.boolean().required(),
    // default: Yup.boolean().required(),
    parameters: Yup.object().when('enabled', (enabled, schema) => {
        if (enabled) {
            return schema.shape({
                baseURL: Yup.string().required(),
                groupId: Yup.string().required(),
                user: Yup.string().required(),
                password: Yup.string().required(),
                smsChannelId: Yup.string().required(),
            });
        }
    }),
});

const pinpointSchema = Yup.object().shape({
    enabled: Yup.boolean().required(),
    // default: Yup.boolean().required(),
    parameters: Yup.object().when('enabled', (enabled, schema) => {
        if (enabled) {
            return schema.shape({
                applicationId: Yup.string().required(),
            });
        }
    }),
});

const awsSchema = Yup.object().shape({
    enabled: Yup.boolean().required(),
    parameters: Yup.object().when('enabled', (enabled, schema) => {
        if (enabled) {
            return schema.shape({
                // No `region` here: it's a single global value read from server config (config/*.yml),
                // used once to instantiate the SES/EUM clients - not something read per-org/per-send.
                // No `identity`/`mailFromDomain` here: SES resolves the verified identity from the
                // sender address itself (set per-send in the send modal, like emailFrom already is for
                // pinpoint/mapp) - domain verification is an AWS-side prerequisite (Fase 4), not a
                // per-org value this app needs to store.
                email: Yup.object().shape({
                    configurationSet: Yup.string(),
                }),
                // No `originationIdentity` here either: EUM uses the per-send `smsFrom` (senderId)
                // directly, same as the modal already does for pinpoint/mapp - it just has to match a
                // Sender ID/number/pool already registered in the AWS account.
                sms: Yup.object().shape({
                    configurationSetName: Yup.string(),
                    optOutListName: Yup.string(),
                }),
                // WhatsApp (EUM Social) provisioning lands in Fase 7 - fields are optional plumbing until then.
                whatsapp: Yup.object().shape({
                    wabaId: Yup.string(),
                    originationPhoneNumberId: Yup.string(),
                }),
            });
        }
    }),
});

export const sendProvidersSchemas = {
    mapp: mappSchema,
    pinpoint: pinpointSchema,
    aws: awsSchema,
};

export const sendProvidersSchema = Yup.object().shape(sendProvidersSchemas);

export default sendProvidersSchema;
